import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    reportsFilterData: []
}
const ReportsFilterSlice = createSlice({
    name: 'reportsFilterFields',
    initialState,
    reducers: {
        handleFilterData(state, action) {
            state.reportsFilterData = action.payload
        }
    }
})

export const { handleFilterData } = ReportsFilterSlice.actions

export default ReportsFilterSlice.reducer
